export const texts = {
    navbar: {
        wallet: { en: "Wallet", ru: "Кошелек" },
        transactions: { en: "Transactions", ru: "Транзакции" },
        customers: { en: "Customers", ru: "Клиенты" },
        users: { en: "Users", ru: "Пользователи" },
        logout: { en: "Log out", ru: "Выйти" }       
    },
    account: {
        addAccount: { en: "Add Account", ru: "Добавить аккаунт" },
        accountName: { en: "Account Name", ru: "Название аккаунта" },
        accountType: { en: "Account Type", ru: "Тип аккаунта" },
        currencies: { en: "Currencies", ru: "Валюты" },
        currency: { en: "Currency", ru: "Валюта" },
        value: { en: "Value", ru: "Значение" },
        average: { en: "Average", ru: "Среднее" },
        remove: { en: "Remove", ru: "Удалить" },
        uploadIcon: { en: "Upload Icon", ru: "Загрузить иконку" },
        myAccounts: { en: "My Accounts", ru: "Мои аккаунты" },
        editing: { en: "Editing", ru: "Редактирование" },
        changeIcon: { en: "Change Icon", ru: "Изменить иконку" },
        addCurrency: { en: "Add Currency", ru: "Добавить валюту" }
    },
    transactions: {
        transactions: { en: "Transactions", ru: "Транзакции" },
        amountRange: { en: "Amount Range", ru: "Диапазон суммы" },
        from: { en: "From", ru: "От" },
        to: { en: "To", ru: "До" },
        currency: { en: "Currency", ru: "Валюта" },
        newPlace: { en: "New Place", ru: "Новое место" },
        history: { en: "History", ru: "История" },
        addTransaction: { en: "Add Transaction", ru: "Добавить транзакцию" },
        place: { en: "Place", ru: "Место" },
        amount: { en: "Amount", ru: "Сумма" },
        rateToAdd: { en: "Rate to Add", ru: "Курс для добавления" },
        addLabel: { en: "Add Label", ru: "Добавить метку" },
        writeComment: { en: "Write your comment here...", ru: "Напишите ваш комментарий здесь..." }
    },
    customer: {
        customerName: { en: "Customer Name", ru: "Имя клиента" },
        customerContact: { en: "Customer Contact", ru: "Контакт клиента" },
        enterCustomerName: { en: "Enter customer name", ru: "Введите имя клиента" },
        enterCustomerContact: { en: "Enter customer contact", ru: "Введите контакт клиента" },
        addComment: { en: "Add Comment", ru: "Добавить комментарий" },
        enterComment: { en: "Enter comment", ru: "Введите комментарий" },
        selectOrCreateUserType: { en: "Select or create user type", ru: "Выберите или создайте тип пользователя" },
        addUser: { en: "Add User", ru: "Добавить пользователя" },
        addCustomer: { en: "Add Customer", ru: "Добавить клиента" },
        customers: { en: "Customers", ru: "Клиенты" },
        searchCustomersByName: { en: "Search customers by name", ru: "Поиск клиентов по имени" },
        name: { en: "Name", ru: "Имя" },
        contact: { en: "Contact", ru: "Контакт" },
        comment: { en: "Comment", ru: "Комментарий" },
        customerType: { en: "Customer Type", ru: "Тип клиента" },
        action: { en: "Action", ru: "Действие" }
    },
    user: {
        addUser: { en: "Add User", ru: "Добавить пользователя" },
        username: { en: "Username", ru: "Имя пользователя" },
        enterUsername: { en: "Enter username", ru: "Введите имя пользователя" },
        password: { en: "Password", ru: "Пароль" },
        enterPassword: { en: "Enter password", ru: "Введите пароль" },
        account: { en: "Account", ru: "Аккаунт" },
        transaction: { en: "Transaction", ru: "Транзакция" },
        customer: { en: "Customer", ru: "Клиент" },
        automation: { en: "Automation", ru: "Автоматизация" },
        users: { en: "Users", ru: "Пользователи" },
        user: { en: "User", ru: "Пользователь" }
    }
}